export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/vi.lyaml"));
at({ "vi": { "public": { "sampleString": "Chu\u1ED7i m\u1EABu" } } });
};